// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1xKII","notes":"Notes_notes__11LeU"};